/* eslint-disable */
export const messagesEN = {
    login: {
        loginHeaderArabian: "Arabian Horse Studbook",
        loginHeaderArabianTwo: "Welcome to Arabian Horse Studbook",
        loginHeaderThoroughbred: "Thoroughbred Studbook",
        loginHeaderThoroughbredTwo: "Welcome to Thoroughbred Studbook",
        title: "Sign in",
        login: "Login",
        password: "Password",
        loginError: "Invalid login credentials",
        email: "Email",
        action: {
            login: "Log in",
            remindPassword: "Forgot password",
            back: "Back",
            backToLogin: "Back to login",
            sendLink: "Send link",
        },
        remindPasswordMsg: "Provide your account email, and we will send a password reset link to that address.",
        successRemindPasswordMail: "Password reset link sent to your email.",
        alreadySent: "You have already sent reset password link on that email.",
        failedLogin: "Too many failed login attempts. Login blocked for 15 minutes.",
        incorrect: "Sorry, your username or password is incorrect.",
    },
    register: {
        title: "Registration",
        fullName: "Full name",
        email: "Email address",
        password: "Password",
        confirmPassword: "Confirm password",
        organisationLevel: "Organisation level",
        organisationName: "Organisation name",
        action: {
            register: "Register",
            backToLogin: "Back to login",
            dontHaveAnAccountYet: "Don't have an account yet?",
        },
    },
    search: {
        search: "search",
        clear: "clear",
    },
    menu: {
        horses: "Horses",
        pending: "Pending",
        stallions: "Stallions",
        broodmares: "Broodmares",
        breedersAndOwners: "Breeders & Owners",
        studbook: "Studbook",
        dictionaries: "Dictionaries",
        seasons: "Seasons",
        studbookTypes: "Studbook types",
        horseColors: "Horse colors",
        eventTypes: "Event types",
        forbiddenNames: "Forbidden names",
        advanced: "Advanced",
        users: "Users",
        laboratories: "Laboratories",
        documents: "Documents",
        filters: "Filters",
        history: "History"
    },
    other: {
        emptyTable: "No results",
        emptyValue: "Empty",
        save: "Save",
        delete: "Delete",
        cancel: "Cancel",
        success: "Success",
        error: "Error",
        dataSaved: "Data saved",
        dataUpdated: "Data updated",
        elementDeleted: "Element deleted",
        avatarDeleted: "Avatar deleted",
        unknownError: "Something went wrong",
        formError: "Form contains errors",
        fileUploaded: "FileUploaded",
        yes: "Yes",
        no: "No",
    },
    validations: {
        required: "This field is required",
        email: "Invalid email format",
        confirmed: "Values are not the same",
        min: "Minimum length: 0:{min}",
        max: "Maximum length: 0:{max}",
        min_value: "Minimum value: 0:{min_value}",
        max_value: "Maximum value: 0:{max_value}",
        is: "",
        regex: "",
        validPassword: "Password must be at least 8 characters long, contain a lowercase letter, an uppercase letter, a number, and a special character",
        notTheSame: "are not the same",
        exactly_15_characters: "Must be exactly 15 characters",
        coveringDateEarlier: "Last covering date can't be earlier then first covering date",
        suffixL: "Suffix must start from L if country is Libya",
        suffixF: "Suffix must start from F if country is other then Libya",
        yearToEarlier: "Year to can't be earlier then year from",
    },
    inputs: {
        selectOnePlaceholder: "select...",
        multiselectPlaceholder: "select...",
        inputTextPlaceholder: "type...",
        inputNumberPlaceholder: "type...",
        calendarPlaceholder: "DD-MM-YYYY",
        selectFromExisting: "select from existing...",
    },
    horseList: {
        header: "Horses",
        newFoalButton: "New foal",
        newImportedHorseButton: "New imported horse",
        status: "Status",
        year: "Year",
        city: "City",
        origin: "Origin",
        yearOrRange: "year or range",
        table: {
            studbookRegistryId: "LYSB registration no",
            ueln: "UELN",
            name: "Name",
            gender: "Gender",
            breeded: "Breeded",
            dateOfBirth: "Date of birth",
            originalStudbookRef: "Original studbook ref",
            coatColor: "Coat color",
        },
    },
    stallionList: {
        header: "Stallions",
        status: "Status",
        year: "Year",
        city: "City",
        origin: "Origin",
        yearOrRange: "year or range",
        table: {
            studbookRegistryId: "LYSB registration no",
            name: "Name",
            dateOfBirth: "Date of birth",
            originalStudbookRef: "Original studbook ref",
            coatColor: "Coat color",
            stallionAgreement: "Stallion agreement",
            offspringCount: "Offspring count",
            details: "View details",
            origin: "Origin",
        },
    },
    documentList: {
        header: "Documents",
        table: {
            date: "Date",
            documentType: "Document Type",
            studbookRegistryId: "LYSB registration no",
            horseName: "Horse Name",
            pdf: "PDF",
        },
    },
    historyList: {
        header: "History log",
        table: {
            date: "Date",
            user: "User",
            role: "Role",
            actionType: "Action type",
            details: "Details",
            refId: "Reference ID",
            name: "Name"
        },
        export: "Export"
    },
    broodmareList: {
        header: "Broodmares",
        status: "Status",
        year: "Year",
        city: "City",
        origin: "Origin",
        yearOrRange: "year or range",
        table: {
            studbookRegistryId: "LYSB registration no",
            name: "Name",
            dateOfBirth: "Date of birth",
            originalStudbookRef: "Original studbook ref",
            coatColor: "Coat color",
            coveringCertificate: "Covering certificate",
            offspringCount: "Offspring count",
            details: "View details",
            origin: "Origin",
        },
    },
    horsePreview: {
        horsePhoto: "Horse photo",
        ueln: "UELN",
        microchip: "Microchip",
        secondMicrochip: "Second microchip",
        imported: "Imported",
        editHorse: "Edit horse",
        cancel: "Cancel",
        delete: "Delete",
        genderIcon: "Horse gender icon",
        success: "Success",
        elementDeleted: "Element deleted",
        error: "Error",
        somethingWentWrong: "Something went wrong",
        qrCodeDownloadButton: "Download QR-code",
        dates: {
            birth: "Birth",
            import: "Import",
            control: "Control",
            export: "Export",
            death: "Death",
            in: "in",
            from: "from",
            by: "by",
            to: "to",
            theUSA: "the USA",
            theUnitedStates: "the United States",
            theUK: "the UK",
            theNetherlands: "the Netherlands",
            thePhilippines: "the Philippines",
        },
        owners: {
            breeders: "Breeders",
            owners: "Owners",
        },
        pedigree: {
            header: "Pedigree",
            seeGenerations: "See 5 generations",
        },
        studbook: {
            statusLabel: "Studbook entry status",
            verified: "Verified",
            pending: "Pending",
            notVerified: "Not verified",
            original: "Original studbook",
            current: "Current studbook",
            referenceNumber: "Reg.n",
            volume: "Vol.",
            supplement: "Supp.",
            page: "P.",
        },
        otherData: {
            genotypeStatusLabel: "Genotype status",
            notesLabel: "Notes",
        },
    },
    horseCreate: {
        saveHorse: "Save horse",
        rejectHorse: "Reject horse",
        submitHorse: "Submit horse",
        submitHorseAnyway: "Submit horse anyway",
        upgradeHorse: "Submit and upgrade",
        registerInStudbook: "Register in studbook",
        importedHorseHeader: "New imported horse",
        foalHeader: "Register a new foal",
        coveringCertificate: "Covering certificate number",
        name: "Name",
        arabianName: "اسم",
        proposedRegistryNumber: "Proposed registry number",
        ueln: "UELN",
        sex: "Gender",
        coatColor: "Coat color",
        dateOfBirth: "Birth date",
        birthPlace: "Birth place",
        sire: "Sire",
        dam: "Dam",
        declarationDate: "Declaration date",
        importedHorseMarkingDataHeader: "Marking data",
        downloadDnaCard: "Download DNA card",
        dnaCard: "DNA result",
        sireDnaCard: "Sire's DNA card",
        damDnaCard: "Dams's DNA card",
        importedHorseDNASample: "DNA samples",
        addPhoto: "Add photo",
        deletePhoto: "Delete photo",
        limbs: "Limbs",
        body: "Body (whorls)",
        onBody: "On body",
        marking: "Marking",
        controlDate: "Control date",
        controlledBy: "Controlled by",
        microchip: "Microchip",
        secondMicrochip: "Second microchip",
        head: "Head",
        starSize: " Star size",
        starPosition: "Star position",
        starRelToWhorl: "Star relation to whorl",
        faceWhorl: "Face whorl",
        stripe: "Stripe",
        snipAndFleshMark: "Snip and flesh mark",
        forelegL: "Foreleg left",
        forelegR: "Foreleg right",
        hindLegL: "Hind leg left",
        hindLegR: "Hind leg right",
        whiteMarks: "White marks",
        spotOnCoronet: "Spot on coronet",
        hoof: "Hoof",
        underMainWhorl: "Under main whorl",
        underMainWhorlLeft: "Under main whorl (Left)",
        underMainWhorlRight: "Under main whorl (Right)",
        underNeckWhorl: "Under neck whorl",
        marks: "Marks",
        position: "Position",
        otherOption: "Other option",
        enterOtherOption: "Enter other option...",
        left: "Left",
        right: "Right",
        samplesFrom: "Samples from",
        hair: "Hair",
        blood: "Blood",
        bone: "Bone",
        ftaCard: "FTA Card",
        batchRefNum: "Batch ref number",
        shipmentDate: "Shipment date",
        testReq: "Test requested",
        testPrior: "Test priority",
        laboratory: "Laboratory",
        strain: "Strain",
        horseClassification: "Horse classification",
        attentionDeclaration: "Attention! Late registration",
        showCountryMissMatchWarning: "Warning! Countries in fields: UELN, birth place and original studbook do not match.",
        registrationBlockedDueToDates: "Cannot save the horse due to difference between date of birth and covering date.",
        registrationBlockedDueToColorMismatch: "Cannot save the horse due to color mismatch.",
    },
    horseEdit: {
        save: "Save",
        delete: "Delete",
        main: {
            menuItem: "Edit horse",
            header: "Edit horse",
            name: "Name",
            arabianName: "اسم",
            registryNumber: "Registry number",
            ueln: "UELN",
            transponderCode: "Microchip",
            secondTransponderCode: "Second microchip",
            sex: "Gender",
            colorId: "Coat color",
            imported: "Imported",
            locallyBreed: "Locally breed",
            deletePhotoButton: "Delete photo",
            addPhotoButton: "Add photo",
            dates: {
                birth: "Birth",
                import: "Import",
                control: "Control",
                export: "Export",
                death: "Death",
                in: "in",
                from: "from",
                by: "by",
                to: "to",
                exportDisclaimer: "In order to set export data add an export event.",
                deathDisclaimer: "In order to set death date add a death event.",
            },
            breedersHeader: "Breeder(s)",
            ownersHeader: "Owner(s)",
            sameAsBreeders: "same as breeder(s)",
            addBreederButton: "Add breeder",
            addOwnerButton: "Add owner",
            createBreederButton: "Create new",
            createOwnerButton: "Create new",
            pedigree: {
                header: "Pedigree",
                seeGenerations: "Edit 5 generations",
                addNewHorseHeader: "Add new horse",
                addNewHorseButton: "Add new",
                name: "Name",
                gender: "Gender",
                coatColor: "Coat color",
                dateOfBirth: "Date of birth",
                ueln: "UELN",
                countryOfBirth: "Country of birth",
                addButton: "Add horse",
                addButtonAnyway: "Add horse anyway",
                newHorseCreated: "New horse created",
            },
            studbook: {
                originalStudbookHeader: "Original studbook",
                currentStudbookHeader: "Current studbook",
                registryId: " Reg.n",
                volume: "Vol.",
                supplement: "Supp.",
                page: "P.",
                bookTypeNamePlaceholder: "book type name",
            },
            genotypeStatusLabel: "Genotype status",
            notes: "Notes",
        },
        events: {
            menuItem: "Events",
            header: "Events",
            date: "Date",
            name: "Name",
            description: "Description",
            add: "Add event",
            eventType: "Event type",
            eventDate: "Event date",
            newOwners: "New owner(s)",
            addOwner: "Add owner",
            createNew: "Create new",
            export: "Export country",
        },
        covering: {
            menuItem: "Covering",
            header: "Covering",
            date: "Date",
            type: "Type",
            season: "Season",
            location: "Location",
            certificateNumber: "Certificate number",
            firstCovering: "First covering date",
            lastCovering: "Last covering date",
            externalStallion: "External stallion",
            notes: "Notes",
            attentionStalion: "Attention! This stallion is younger than 24 months.",
            attentionBroodmare: "Attention! This broodmare is younger than 36 months.",
            tableHeaderStallion: "Stallions agreement",
            tableHeaderMare: "Horse covering certificates",
            newAgreement: "New agreement",
            newCertificate: "New certificate",
            agreementType: "Agreement type",
            certificateNum: "Certificate numbers (from-to)",
            addAgreement: "Add agreement",
            dialogAgreementHeader: "Covering agreement for ",
            dialogCertificateHeader: "Covering certificate for ",
            number: "Number",
            broodmare: "Broodmare",
            coveringType: "Covering type",
            semen: "Semen",
            results: "Results",
            mare: "Broodmare",
            addCertificate: "Add certificate",
            addExternalStallionAndCertificate: "Add stallion and certificate",
            addExternalStallionAndUseCertificate: "Add certificate",
            semenType: "Semen type",
            semenOrigin: "Origin",
            addResult: "Add result",
            addFoal: "Add foal",
            dialogResultHeader: "Covering result for ",
            numberResult: "Covering certificate number",
            resultType: "Result type",
            externalStallionDisclaimer: "Enter the stallion’s details that will be linked to the certificate.",
            externalStallionExistsDisclaimer: "The list below contains similar horses already in the system. If you want to use an existing horse instead of creating a new one, click the plus button."
        },
        offspring: {
            menuItem: "Offspring",
            header: "Offspring",
            table: {
                ueln: "UELN",
                name: "Name",
                gender: "Gender",
                breeded: "Breeded",
                dateOfBirth: "Date of birth",
                originalStudbookRef: "Original studbook ref",
                coatColor: "Coat color",
                details: "Details",
            },
        },
        laboratory: {
            menuItem: "Laboratory",
            header: "Laboratory",
        },
        documents: {
            menuItem: "Documents",
            header: "Documents",
            date: "Date",
            documentType: "Type",
            downloadPdf: "PDF",
            generate: {
                action: "Generate",
                header: "Generate document",
                documentType: "Document type",
            },
            generatePassport: "generate passport",
            qrCodeStudbookLabel: "Official studbook registry page",
            qrCodeProfileLabel: "Horse profile registry page",
            qrCodeDownloadButton: "Download QR-code",
        },
        history: {
            menuItem: "History",
            header: "Modifications history",
            table: {
                version: "Version",
                date: "Date",
                user: "User"
            },
            revision: {
                author: "Author",
                date: "Date",
            }
        }
    },
    horsePending: {
        header: "Horse Pending Approval",
        table: {
            ueln: "UELN",
            name: "Name",
            gender: "Gender",
            breeded: "Breeded",
            dateOfBirth: "Date of birth",
            originalStudbookRef: "Original studbook ref",
            coatColor: "Coat color",
            detailedStatus: "Detailed status",
            details: "View details",
            origin: "Origin",
        },
    },
    laboratoryHorses: {
        table: {
            header: "Scanned horses",
            ueln: "UELN",
            name: "Name",
            sire: "Sire",
            dam: "Dam",
            coatColor: "Coat color",
            details: "View details",
        },
        form: {
            header: "Verify horse parentage",
            dna: "DNA samples",
            emptyTable: "No DNA samples found",
            sire: "Sire",
            dam: "Dam",
            horseId: "Horse id",
            gender: "Gender",
            coatColor: "Coat color",
            testRes: "Test result",
            why: "Why",
            samplesFrom: "Samples from",
            batchRef: "Batch ref number",
            testReq: "Test requested",
            testPrior: "Test priority",
            shipment: "Shipment date",
            dnaRef: "DNA reference",
            receipt: "Receipt date",
            dnaCard: "Dna result file",
            comments: "comments",
            name: "name",
            dnaDoc: "DNA document",
            save: "Save",
            submit: "Submit",
        },
    },
    studbookType: {
        header: "Studbook Types",
        headerNew: "New studbook type",
        headerEdit: "Edit studbook Type",
        addNewButton: "New studbook type",
        abbreviation: "Abbreviation",
        code: "Studbook code",
        authority: "Studbook authority",
        studbookCode: "Studbook code",
        name: "Name",
        libyanShort: "Libyan",
        libyan: "Specific to Libya, not temporary",
        country: "Country",
        countryCode: "Country Code",
    },
    eventType: {
        header: "Event Types",
        headerNew: "New event type",
        headerEdit: "Edit event type",
        addNewButton: "New event type",
        name: "Name",
    },
    forbiddenName: {
        header: "Forbidden names",
        headerNew: "New forbidden name",
        headerEdit: "Edit forbidden name",
        addNewButton: "New forbidden name",
        name: "Name",
    },
    season: {
        header: "Season",
        year: "Year",
        startDate: "Start date",
        endDate: "End date",
        active: "Active",
        addNewButton: "New season",
        headerNew: "New season",
        headerEdit: "Edit season",
        minDate: "Min date",
        maxDate: "Max date",
    },
    horseColor: {
        header: "Horse Coat Colors",
        headerNew: "New horse coat color",
        headerEdit: "Edit horse coat color",
        addNewButton: "New horse coat color",
        name: "Name",
        nameLong: "Full name",
        abbreviation: "Abbreviation",
        abbreviationLong: "Abbreviation name",
    },
    owner: {
        header: "Breeders & Owners",
        headerNew: "New Breeder/Owner",
        headerEdit: "Edit Breeder/Owner",
        addNewButton: "Add new breeder/owner",
        id: "ID",
        suffix: "Suffix",
        code: "Code",
        name: "Name",
        fullName: "Full name",
        businessNumber: "Business number",
        nationalIdNumber: "National ID number",
        phoneNumber: "Phone number",
        email: "Email",
        farmName: "Farm name",
        isACompany: "Is a company?",
        notes: "Notes",
        history: "History",
        isOwner: "Is Owner",
        isBreeder: "Is Breeder",
        address: {
            postalCode: "Postal code",
            city: "City",
            street: "Street",
            propertyNumber: "Property number",
            apartmentNumber: "Apartment number",
            country: "Country",
            region: "Region",
        },
    },
    filters: {
        header: "Filters",
        horseFilters: "Horse filters",
        labFilters: "Laboratory activity filters",
        eventFilters: "Event filters",
        passportFilters: "Passport filters",
        generateButton: "Generate report",
        covering: "Covering filters",
        agreement: "Stallions agreement filters",
        broodmare: "Broodmares with their produce",
        stallion: "Stallions with their progeny",
        deceased: "Deceased filters",
        owners: "Owners filters",
        breeders: "Breeders filters",
        passport: "Passport filters",
        inputs: {
            microchip: "Microchip",
            registryNumber: "Registry number",
            ueln: "UELN",
            sire: "Sire",
            dam: "Dam",
            dnaRes: "DNA result type",
            breeder: "Breeder",
            owner: "Owner",
            year: "Year",
            season: "Season",
            city: "City",
            studbookStatus: "Studbook status",
            studbookVolume: "Studbook volume",
            sex: "Gender",
            coatColor: "Coat color",
            import: "Imported",
            export: "Exported",
            deceased: "Deceased",
            originCountry: "Country of origin",
            destinationCountry: "Country of destination",
            placeOfBirth: "Place of birth",
            placeOfCovering: "Place of covering",
            placeOfAgreement: "Place of agreement",
            placeOfFarmStud: "Place of farm/stud",
            locallyBreed: "Locally breed",
            result: "Result",
            agreement: "Agreement type",
            foalGender: "Foal gender",
            farms: "Farms",
            yearFrom: "Year from",
            yearTo: "Year to",
            volume: "Volume",
        },
        generateStudbook: "Generate studbook",
        studbookTaskStatus: {
            inprogress: "Generating studbook...",
            completed: "Studbook ready",
            failed: "Latest generation failed",
            cancelled: "Generation cancelled",
        },
        cancelGeneration: "Cancel generation",
        downloadStudbook: "Download studbook",
        generationInProgress: "A studbook is being generated. Please wait.",
        studbookInfo: "Volume {volume}, {yearFrom}-{yearTo}, completed {completedAt}",
        errorMessage: "Error",
        previousStudbookAvailable: "Studbook available",
        downloadPreviousStudbook: "Download studbook",
    },
    user: {
        header: "Users",
        headerNew: "New User",
        headerEdit: "Edit User",
        addNewButton: "Add new user",
        id: "ID",
        fullName: "Full name",
        email: "Email address",
        userType: "User type",
        whichLab: "Which lab",
    },
    errorPage: {
        back: "Back to main page",
        contact: "Please contact the system administrator",
        pageNotFound: "Page not found",
        error: "Error",
        accessDenied: "Access denied",
    },
    unknownError: "Something went wrong",
    import: {
        title: "Import Horses",
        description: "Upload Excel files to import horses into the system.",
        externalHorses: "External Horses",
        externalHorsesDescription: "Import horses from external studbooks.",
        localHorses: "Local Horses",
        localHorsesDescription: "Import horses bred locally.",
        dragDropExcelFile: "Drag and drop Excel file here to upload.",
        fileUploadedSuccessfully: "File uploaded and import completed successfully.",
        instructions: "Import Instructions",
        instruction1: "Only Excel files (.xlsx, .xls) are accepted.",
        instruction2: "The file must follow the required format.",
        instruction3: "Import will process automatically after file is selected.",
        instruction4: "Works only for ARABIAN horses.",
    },
    existHorse: {
        horseExist: "Horse may exist",
        name: "Name",
        countryOfBirth: "Country of birth",
        dateOfBirth: "Date of birth",
        color: "Color",
        ueln: "Ueln",
        details: "View details",
        useHorse: "Use horse",
        sex: "Gender"
    },
};
